// TinyMCE renders dialogs/menus in body, outside any modal. Stop focus events
// involving them from reaching reka-ui's FocusScope (shadcn Dialog), which
// listens natively on document and would otherwise yank focus back into the
// modal. Native listeners on purpose: jQuery 3.7 simulates focusin/focusout, so
// a jQuery handler's stopImmediatePropagation never reaches native listeners
// (and vice versa: this does not guard jQuery-based traps like Bootstrap's).
// Registered at bootstrap so it runs before any later-added document listener.
const TINYMCE_UI_SELECTOR = '.tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root'

function isTinymceUi(node) {
  return node instanceof Element && node.closest(TINYMCE_UI_SELECTOR) !== null
}

document.addEventListener('focusin', (e) => {
  if (isTinymceUi(e.target)) {
    e.stopImmediatePropagation()
  }
})

document.addEventListener('focusout', (e) => {
  if (isTinymceUi(e.relatedTarget)) {
    e.stopImmediatePropagation()
  }
})
